import { FC, useState, useEffect, MouseEvent } from 'react';
import { IClassicItem, INavItem } from 'mod/store/nav/interface';
import { Row, Col } from '@base/lib/ThemeGrid';
import Iconfont from '@base/lib/Iconfont'
import cn from 'classnames';
import { moduleId, track } from 'mod/store/nav/utils';
import { displayCtr } from 'base/utils/tracker';
import { NavLink } from 'mod/store/nav/NavLink';
import { useStoreState } from 'base/store';

type INavClassicListProps = {
    list: IClassicItem[];
    lv1Item: INavItem;
    lv1Index: number;
    onClose?: () => void;
};

export const NavClassicList: FC<INavClassicListProps> = props => {
    const { lv1Item, lv1Index, list, onClose } = props;
    const [activeLv2Index, setActiveLv2Index] = useState<number>(-1);
    const activeLv2Item = list[activeLv2Index];
    const { ua: { isMobile } } = useStoreState('rootStore');

    const handleMobileClick = (e: React.MouseEvent, index: number) => {
        if (index !== activeLv2Index && list[index].list.length > 0) {
            e.preventDefault();
            setActiveLv2Index(index);
        } else {
            if (list[index].list.length === 0) {
                setActiveLv2Index(-1);
            }
            if (list[index].link) {
                onClose?.();
            }
        }
    };

    useEffect(() => {
        if (activeLv2Index !== -1 && activeLv2Item.list.length > 0) {
            track({
                action: 'impr',
                target: activeLv2Item.link || activeLv2Item.title,
                relTarget: activeLv2Item.link || activeLv2Item.title,
                position: `${lv1Index + 1}.${activeLv2Index + 1}`,
            });

            displayCtr(moduleId);
        }
    }, [activeLv2Index]);

    useEffect(() => {
        if (lv1Index !== -1 && list[0]?.list.length > 0) {
            setActiveLv2Index(0);
        } else {
            setActiveLv2Index(-1);
        }
    }, [lv1Index]);


    return (
        <Row colsPerRow={2} className={'g-classic'}>
            <Col className={'g-classic-left'}>
                <h3 className={'g-classic-title'}>
                    <NavLink
                        item={lv1Item}
                        target={`title:${lv1Item.link || lv1Item.title}`}
                        relTarget={lv1Item}
                        position={`title.${lv1Index + 1}`}
                        onClose={onClose}
                    >
                        {lv1Item.title}{lv1Item.link ? ' >' : ''}
                    </NavLink>
                </h3>
                <div className={'g-classic-menu'}>
                    {list.map((lv2Item, lv2Index) => {
                        const hasChild = lv2Item.list.length > 0;
                        return (
                            <NavLink
                                key={lv2Index}
                                item={lv2Item}
                                relTarget={lv1Item}
                                position={`${lv1Index + 1}.${lv2Index + 1}`}
                                className={
                                    hasChild
                                        ? cn('g-level2-trigger', { 'g-active': activeLv2Index === lv2Index })
                                        : 'block'
                                }
                                // 移动端需要在子菜单展示后再跳转
                                {...(isMobile ? {
                                    onClick: e => handleMobileClick(e as MouseEvent, lv2Index)
                                } : {
                                    onMouseEnter: () => setActiveLv2Index(hasChild ? lv2Index : -1),
                                    onClose
                                })}
                            >
                                <span>{lv2Item.title}</span>
                                {hasChild && <Iconfont className={'icon-arrow-right'}/>}
                            </NavLink>
                        )
                    })}
                </div>
            </Col>
            {activeLv2Item && activeLv2Item.list.length > 0 && (
                <Col className={'g-classic-right'}>
                    <h3 className={'g-classic-title'}>
                        <NavLink
                            item={activeLv2Item}
                            target={`title:${activeLv2Item.link || activeLv2Item.title}`}
                            relTarget={activeLv2Item}
                            position={`title.${lv1Index + 1}.${activeLv2Index + 1}`}
                            onClose={onClose}
                        >
                            {activeLv2Item.title} &gt;
                        </NavLink>
                    </h3>
                    <div className={'g-classic-menu'}>
                        {activeLv2Item.list.map((lv3Item, lv3Index) => (
                            <NavLink
                                key={lv3Index}
                                item={lv3Item}
                                relTarget={activeLv2Item}
                                position={`${lv1Index + 1}.${activeLv2Index + 1}.${lv3Index + 1}`}
                                className={'block'}
                                onClose={onClose}
                            >
                                {lv3Item.title}
                            </NavLink>
                        ))}
                    </div>
                </Col>
            )}
        </Row>
    )
};
